import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";

let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage,
  Loja: "planner",
  UserStorage: "Ayin85JfhEKgwIREfZVM3w==",
  UserToken: "I6hTo4s8kkyhOsyn3fHqBA==",
  UrlApi: "https://hlg-ecommerce-pln-api.primecase.com.br/api",
  UrlLoja:"https://hlg-ecommerce-pln-web.primecase.com.br",
  UrlServiceHost: "https://dev2-pri-sgc-api.primecase.com.br/",
  SecurityKey: "",
  OrgId: "",
  ProviderMerchantId: ""
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#0d1d74",
      light: "#0088ce",
      //lighter: "#ece6f7",
      dark: darkenColor("#0d1d74", 10),
    },
    secondary: {
      main: "#8f12a3",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
